import { z } from 'zod'

export const positionAssessmentLevelRowSchema = z.object({
  positionTemplateId: z.number(),
  positionTemplateName: z.string(),
  workerRequirementId: z.number(),
  workerRequirementName: z.string(),
  level: z.number(),
})

export type PositionAssessmentLevelRow = z.infer<
  typeof positionAssessmentLevelRowSchema
>

export const getPositionAssessmentLevelsFilterRequestSchema = z.object({
  positionTemplateId: z.number().optional(),
  maxLevel: z.number().optional(),
})

export type GetPositionAssessmentLevelsFilterRequest = z.infer<
  typeof getPositionAssessmentLevelsFilterRequestSchema
>
